import React from "react";
import { useApp } from "../context/AppContext";

const ICONS = { success: "bi-check-circle-fill", danger: "bi-exclamation-circle-fill", info: "bi-info-circle-fill" };

function Toasts() {
  const { toasts, dismissToast } = useApp();
  return (
    <div className="toast-stack" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`app-toast app-toast-${t.variant}`} role="status">
          <i className={`bi ${ICONS[t.variant] || ICONS.info}`} />
          <span className="flex-grow-1">{t.message}</span>
          <button className="btn-close btn-close-white btn-sm" aria-label="Dismiss" onClick={() => dismissToast(t.id)} />
        </div>
      ))}
    </div>
  );
}

export default Toasts;
